import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

export default class extends Controller {
    static values = { updateUrl: String }

    toggle(event) {
        const checkbox = event.target
        const index = checkbox.dataset.index
        const completed = checkbox.checked
        const url = `${this.updateUrlValue}?index=${index}&completed=${completed}`

        // 楽観的UI更新: チェック状態を即座に反映
        const itemContainer = checkbox.closest(`[id="checklist-item-${index}"]`)
        if (itemContainer) {
            const titleEl = itemContainer.querySelector('.checklist-title')
            const descEl = itemContainer.querySelector('.checklist-description')
            if (titleEl) {
                if (completed) {
                    titleEl.classList.add('line-through', 'text-gray-400', 'dark:text-gray-500')
                } else {
                    titleEl.classList.remove('line-through', 'text-gray-400', 'dark:text-gray-500')
                }
            }
            if (descEl) {
                if (completed) {
                    descEl.classList.add('opacity-50')
                } else {
                    descEl.classList.remove('opacity-50')
                }
            }
        }

        fetch(url, {
            method: "PATCH",
            headers: {
                "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
                "Accept": "text/vnd.turbo-stream.html"
            }
        })
            .then(response => {
                if (!response.ok) throw new Error("Network response was not ok");
                return response.text();
            })
            .then(html => {
                Turbo.renderStreamMessage(html);
            })
            .catch(error => {
                console.error("Error updating progress:", error)
                // エラー時はチェック状態をロールバック
                checkbox.checked = !completed
                if (itemContainer) {
                    const titleEl = itemContainer.querySelector('.checklist-title')
                    const descEl = itemContainer.querySelector('.checklist-description')
                    if (titleEl) {
                        if (!completed) {
                            titleEl.classList.add('line-through', 'text-gray-400', 'dark:text-gray-500')
                        } else {
                            titleEl.classList.remove('line-through', 'text-gray-400', 'dark:text-gray-500')
                        }
                    }
                    if (descEl) {
                        if (!completed) {
                            descEl.classList.add('opacity-50')
                        } else {
                            descEl.classList.remove('opacity-50')
                        }
                    }
                }
            })
    }
}
